import { allMetadata } from 'constants/metadata';
import { questions as questionsBreadcrumbs } from 'constants/routes-breadcrumbs';
import { Routes } from 'constants/routes';
import { IQuestion } from 'constants/types';
import { getItemIdentifier } from 'utils/slug';
import { TopicThreadPage } from 'components/template/topic-thread';

interface Props {
  mainQuestion: IQuestion;
  childrenQuestions: IQuestion[];
}

export const QuestionPage = ({ mainQuestion, childrenQuestions }: Props) => {
  return (
    <TopicThreadPage
      variant="question"
      mainItem={mainQuestion}
      childrenItems={childrenQuestions}
      metadata={allMetadata.question(mainQuestion)}
      breadcrumbs={[
        ...questionsBreadcrumbs,
        {
          id: 2,
          path: Routes.question(getItemIdentifier(mainQuestion)),
          title: mainQuestion?.title ?? '',
        },
      ]}
    />
  );
};
